import React, { useEffect, useState } from 'react';

import Layout from 'antd/lib/layout';

import { Switch, Route, useLocation } from 'react-router-dom';
import { getBuildingList, getAlertsCount } from '../../API';

import HeaderControl from '../Header/Header';
import MapView from '../MapView/MapView';
import { MonitoringPage } from '../MonitoringPage';
import { AlertsPage } from '../AlertsPage';
import { SettingsPage } from '../SettingsPage';
import { HelpPage } from '../HelpPage';
import { PageNotFound } from '../PageNotFound';
import { SideControl } from '../SideControl';

import { config } from '../../config';

import './PiConsole.less';

const { REACT_APP_BUILD_ENV } = config;

const PiConsole = (props) => {
  const { Content } = Layout;

  const { theme, changeTheme } = props;
  const { pathname } = useLocation();

  const [loadingBuildings, setIsLoadingBuildings] = useState(true);

  const [buildings, setBuildings] = useState([]);
  const [isAddBuildingModalOpen, setIsAddBuildingModalOpen] = useState(false);

  const [selectedBuildingId, setSelectedBuildingId] = useState('');
  const [selectedBuildingInfo, setSelectedBuildingInfo] = useState({});

  const mapAlertsToBuildings = (buildingsList, alertsList) => {
    const alertLookup = new Map(alertsList.map((a) => [a.building_identifier, a.alert_count]));
    const mappedBuildingsList = buildingsList.map((b) => ({
      ...b,
      alert_count: alertLookup.get(b.identifier) || 0,
    }));
    return mappedBuildingsList;
  };

  const fetchAlertsCount = async (buildingsList) => {
    const buildingAlertsList = await getAlertsCount(REACT_APP_BUILD_ENV);
    const updatedBuildingsList = mapAlertsToBuildings(buildingsList, buildingAlertsList);
    setBuildings(updatedBuildingsList);
  };

  useEffect(() => {
    async function fetchBuildings() {
      setIsLoadingBuildings(true);
      let buildingsList = await getBuildingList(REACT_APP_BUILD_ENV);

      const buildingAlertsList = await getAlertsCount(REACT_APP_BUILD_ENV);

      buildingsList = mapAlertsToBuildings(buildingsList, buildingAlertsList);
      setBuildings(buildingsList);
      setIsLoadingBuildings(false);
    }

    if (!buildings || buildings.length === 0) {
      fetchBuildings();
    }
    if (pathname === '/') {
      fetchAlertsCount(buildings);
    }
  }, [pathname]);

  const selectBuilding = (building) => {
    if (Object.keys(building).length !== 0) {
      setSelectedBuildingInfo({ ...building, postalCode: building.postal_code });
      setSelectedBuildingId(building.identifier);
      sessionStorage.setItem('selectedBuilding', JSON.stringify(building));
    } else {
      setSelectedBuildingInfo({});
      setSelectedBuildingId('');
      sessionStorage.setItem('selectedBuilding', {});
    }
  };

  return (
    <Layout className={`ant-layout-has-sider-${theme} pi-console`}>
      <SideControl
        buildings={buildings}
        selectedBuildingId={selectedBuildingId}
        selectBuilding={selectBuilding}
        setIsAddBuildingModalOpen={setIsAddBuildingModalOpen}
        theme={theme}
        fetchAlertsCount={fetchAlertsCount}
        loadingBuildings={loadingBuildings}
      />
      <Content className='pi-console-head'>
        <HeaderControl
          buildings={buildings}
          selectBuilding={selectBuilding}
          selectedBuildingId={selectedBuildingId}
          addBuilding={() => setIsAddBuildingModalOpen(true)} // Used on Mobile
          setSelectedBuildingId={setSelectedBuildingId}
          selectedBuildingInfo={selectedBuildingInfo}
          setSelectedBuildingInfo={setSelectedBuildingInfo}
          theme={theme}
          changeTheme={changeTheme}
        />
        <div className={`landing-wrapper ${pathname === '/' ? 'disable-map' : ''}`}>
          <Switch>
            <Route
              exact
              path="/"
              render={() => {
                return (
                  <MapView
                    buildings={buildings}
                    changeTheme={changeTheme}
                    selectBuilding={selectBuilding}
                    selectedBuildingId={selectedBuildingId}
                    setSelectedBuildingId={setSelectedBuildingId}
                    selectedBuildingInfo={selectedBuildingInfo}
                    setSelectedBuildingInfo={setSelectedBuildingInfo}
                    isAddBuildingModalOpen={isAddBuildingModalOpen}
                    setIsAddBuildingModalOpen={setIsAddBuildingModalOpen}
                    theme={theme}
                  />
                );
              }}
            />
            <Route
              exact
              path="/monitoring/:building"
              render={() => {
                return <MonitoringPage theme={theme} buildings={buildings} />;
              }}
            />
            <Route
              exact
              path="/alerts/:building"
              render={() => {
                return <AlertsPage theme={theme} buildings={buildings} buildingName={selectedBuildingId} />;
              }}
            />
            <Route
              exact
              path="/settings"
              render={() => {
                return <SettingsPage theme={theme} />;
              }}
            />
            <Route
              exact
              path="/help"
              render={() => {
                return <HelpPage theme={theme} />;
              }}
            />
            <Route
              path="*"
              render={() => {
                return <PageNotFound theme={theme} selectBuilding={selectBuilding} />;
              }}
            />
          </Switch>
        </div>
      </Content>
    </Layout>
  );
};

export default PiConsole;
